/**
 * Retention. Destination: `@renote/contracts`.
 *
 * Soft-deleted notes and tasks accumulate forever otherwise. This is the one
 * genuinely irreversible operation in the module, so the shape is deliberately
 * awkward to invoke by accident.
 */

import { z } from 'zod'
import { boolParam, instant, intParam } from './common'

/**
 * A week is the floor, not a suggestion. The purpose of the soft delete is that
 * someone can change their mind, and a mistyped `1` would defeat that for
 * everything deleted yesterday. Ten years is the ceiling simply because a larger
 * number is more likely to be a units mistake than an intention.
 */
export const MIN_RETENTION_DAYS = 7
export const DEFAULT_RETENTION_DAYS = 90

export const purgeInput = z
  .object({
    olderThanDays: intParam(MIN_RETENTION_DAYS, 3650).default(DEFAULT_RETENTION_DAYS),
    /** Reports what would go without removing anything. */
    dryRun: boolParam.default(false),
  })
  .strict()
export type PurgeInput = z.infer<typeof purgeInput>

export const purgeResult = z.object({
  cutoff: instant,
  dryRun: z.boolean(),
  notes: z.number().int().nonnegative(),
  tasks: z.number().int().nonnegative(),
})
export type PurgeResult = z.infer<typeof purgeResult>
